<div class="offer-unavailable-dialog">
    <div class="offer-unavailable-dialog__header">
        <div *ngIf="additionalLogoUrl" class="offer-unavailable-dialog__additional-logo">
            <img [src]="additionalLogoUrl" alt="">
        </div>
        <div *ngIf="additionalLogoUrl" class="offer-unavailable-dialog__divider"></div>
        <div *ngIf="logoVisible" class="offer-unavailable-dialog__logo">
            <img [src]="logoUrl" alt="">
        </div>
    </div>
    <div class="offer-unavailable-dialog__title"
         [innerHTML]="getTranslationKey('title') | translate | safeHtml"
    ></div>
    <div class="offer-unavailable-dialog__subtitle"
         [innerHTML]="getTranslationKey('subtitle') | translate | safeHtml"
    ></div>
    <div class="offer-unavailable-dialog__image">
        <img [src]="imageUrl" alt="">
    </div>
    <div class="offer-unavailable-dialog__button">
        <button (click)="backToOffers()"
                class="btn btn--secondary btn--big btn--no-outline">
            {{ getTranslationKey('buttonText') | translate }}
        </button>
    </div>
</div>
